module.exports = __webpack_public_path__ + "img/aboutImage.0513ccb1.webp";